<page-content>
    <header-elitment header>
    </header-elitment>
    <module-content [title]="'Organizations'"
                    [mainActions]="mainActions">
        <div *ngIf="dataSource.data.value.length === 0" class="legend">
            <p>{{ 'No_organization_yet' | translate }}</p>
            <p>
                <button
                    mat-raised-button
                    color="accent"
                    [disabled]="isRefreshLoading"
                    (click)="onRefreshDataClick()">
                    {{ 'Refresh' | translate }}
                </button>
            </p>
        </div>
        <mat-table *ngIf="dataSource.data.value.length > 0"
                   [dataSource]="dataSource">
            <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: columns"></mat-row>
            <ng-container matColumnDef="image">
                <mat-header-cell *matHeaderCellDef class="image-cell"></mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" class="image-cell">
                    <img *ngIf="row.image"
                         [ngSrc]="conf.storageRootUrl + row.image" alt="organization image" width="48" height="48"/>
                    <mat-icon *ngIf="!row.image">
                        cloud
                    </mat-icon>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef class="name-cell"></mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" class="name-cell">
                    <button mat-button
                            [routerLink]="'/' + row.code">
                        {{ row.name }}
                    </button>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="actions">
                <mat-header-cell *matHeaderCellDef class="actions-cell"></mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" class="actions-cell">
                    <button *ngIf="1>2" mat-icon-button [matMenuTriggerFor]="rowMoreMenu">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #rowMoreMenu="matMenu" xPosition="before">
                        <button mat-menu-item
                                (click)="onEditClicked($event, i)">
                            {{ 'Modify' | translate }}
                        </button>
                        <button mat-menu-item
                                (click)="onDeleteClicked($event, i)">
                            {{ 'Delete' | translate }}
                        </button>
                    </mat-menu>
                </mat-cell>
            </ng-container>
        </mat-table>
    </module-content>
    <footer-elitment footer></footer-elitment>
</page-content>
